import * as React from 'react';
export const IcToddler = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20 11h-.07A8 8 0 0012 4a7.67 7.67 0 00-1.45.14l-.84-.85a1.004 1.004 0 00-1.42 1.42l.14.14A8 8 0 004.07 11H4a1 1 0 000 2h.07a8 8 0 0015.86 0H20a1 1 0 100-2zm-13-.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm8.28 5.25a4.93 4.93 0 01-6.56 0 1 1 0 01.094-1.57A1 1 0 019.38 14h5.24a1 1 0 01.966 1.242 1 1 0 01-.306.508zM15.5 12a1.5 1.5 0 110-3 1.5 1.5 0 010 3z'
      fill='currentColor'
    />
  </svg>
);
